export default {
  state: {
    page: 1,
    count: 0,
    data: []
  },
  mutations: {
    ChangePage: (state, payload) => {
      state.page = payload
    },
    ChangeCount: (state, payload) => {
      state.count = payload
    }
  },
  getters: {
    getShareLabPage: state => state.page,
    getShareLabCount: state => state.count,
  },
  actions: {
    changePage: ({ commit }, payload) => {
      commit('ChangePage', payload)
    },
    changeCount: ({ commit }, payload) => {
      commit('ChangeCount', payload)
    },
  }
}


// WEBPACK FOOTER //
// ./src/Views/ShareLab/store.js